"use client";

import CartContextProvider from "@/context/CartContext";
import WishlistProvider from "@/context/WishlistContext";
import AuthProvider from "@/app/providers/authProvider";

export default function Providers({ children }) {
  return (
      <AuthProvider>
        <WishlistProvider>
          <CartContextProvider>
              {children}
          </CartContextProvider>
        </WishlistProvider>
      </AuthProvider>
  );
}
